import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import StackView from '../StackView';

var BodyCell = function BodyCell(props) {
  return /*#__PURE__*/React.createElement(StackView, _extends({
    role: "cell",
    axis: "horizontal",
    shrink: 0,
    paddingVertical: 0.5
  }, props));
};

export default BodyCell;